<template>
    <div data-testid="profile-card-price">
        <VJoyTooltip :text="tooltipText || (price.visibility === 'ON_DEMAND' ? '' : $t('profile.card.price.tooltip'))" variant="primary">
            <VJoyWrapper no-margin row-gap="1" column-gap="1" wrap="nowrap" align="flex-start">
                <VJoyIcon name="cost-plus" />
                <p v-if="price.visibility === 'ON_DEMAND'">
                    {{ $t('profile.card.price.non.available') }}
                </p>
                <p
                    v-else
                    class="profile-card-price__label"
                    v-html="$t('profile.card.price.label.short.v2', {rateUnit: 'DAILY', formattedPrice: price.formattedValue})"
                />
            </VJoyWrapper>
        </VJoyTooltip>
    </div>
</template>

<script setup lang="ts">
    import type {PriceVisibility} from '@profile-card/components/profile-card/types';
    import {VJoyIcon, VJoyTooltip, VJoyWrapper} from '@maltjoy/core-vue';

    defineProps<{
        price: PriceVisibility;
        tooltipText?: string;
    }>();
</script>

<style scoped lang="scss">
    .profile-card-price {
        &__label {
            font-weight: var(--joy-font-weight-bold);
        }
    }
</style>
